// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b1bf2110","455":"9bc96868","488":"beda054b","977":"f845ed49"}[chunkId] + ".chunk.js";
};